import * as config from "config";
import { useEffect } from "react";
import * as staticDataService from "services/staticDataService";
import * as stateHooks from "store/hooks/stateHooks";

export const useFeatureFlag = (flag, { default: _default = false } = {}) => {
  const {
    data: featureFlags,
    isLoading: isFeatureFlagsLoading,
  } = staticDataService.useFeatureFlagsQuery();
  const {
    data: featuresConfig,
    isLoading: isConfigLoading,
  } = staticDataService.useConfigQuery("features");

  const isLoading = isFeatureFlagsLoading || isConfigLoading;

  const [betaFlags, setBetaFlags] = stateHooks.useLocalStorageJsonState(
    "featureFlagBetaFlags"
  );

  const setBetaFlag = (betaFlag) => {
    setBetaFlags({ ...betaFlags, [flag]: betaFlag });
  };

  const isFeatureFlagOn = !!(featureFlags?.[flag] ?? _default);

  const betaConfig = featuresConfig?.betaFlags?.[flag] ?? {};
  const isBetaFlaggingEnabled = betaConfig.isEnabled ?? false;
  const isBetaFlagSet = betaFlags?.[flag] != null;
  const isBetaFlagOn = betaFlags?.[flag] ?? betaConfig?.default ?? false;

  return {
    isOn: isFeatureFlagOn && (!isBetaFlaggingEnabled || isBetaFlagOn),
    isFeatureFlagOn,
    isBetaFlaggingEnabled,
    isBetaFlagSet,
    isBetaFlagOn,
    isLoading,
    setBetaFlag,
  };
};

export const useLocalStorageFeatureFlags = () => {
  const { data, isLoading } = staticDataService.useFeatureFlagsQuery(null, {
    pollingInterval: config.FEATURE_FLAG_POLLING_INTERVAL_MS,
  });

  const [, setFeatureFlags] = stateHooks.useLocalStorageJsonState(
    "featureFlags"
  );

  useEffect(() => {
    if (!isLoading && data) {
      setFeatureFlags(data);
    }
  }, [data, isLoading, setFeatureFlags]);
};
